<template>
  <div>
    <el-row class="row-bg">
      <el-button-group>
        <el-button
          :type="timeType === item.value ? 'primary': ''"
          v-for="item in dateTypeDict"
          :key="item.value
"
          @click="setDateType(item)"
        >{{item.label}}
        </el-button>
      </el-button-group>
    </el-row>
    <enquiry-count
      :time-type="timeType"
      :customer-id="customerId"
      :service="service.inquiryTrend"
    ></enquiry-count>
    <el-row
      :gutter="20"
      type="flex"
      class="block-indent"
    >
      <el-col :span="12">
        <enquiry-industry
          :time-type="timeType"
          :customer-id="customerId"
          :service="service.inquiryIndustry"
        ></enquiry-industry>
      </el-col>
      <el-col :span="12">
        <enquiry-region
          :time-type="timeType"
          :customer-id="customerId"
          :service="service.inquiryRegion"
        ></enquiry-region>
      </el-col>
    </el-row>
    <el-row class="block-indent">
      <enquiry-service
        :time-type="timeType"
        :customer-id="customerId"
        :service="service.inquiryService"
      ></enquiry-service>
    </el-row>
  </div>
</template>

<script>
import VeLine from "v-charts/lib/line.common";
import VePie from "v-charts/lib/pie.common";

import inquiry from "@/backend/services/enquiry/enquiry";
import { dateType, websiteType } from "@/common/dictionary";
import enquiryCount from "@/components/enquiry/enquiryCount";
import enquiryIndustry from "@/components/enquiry/enquiryIndustry";
import enquiryRegion from "@/components/enquiry/enquiryRegion";
import enquiryService from "@/components/enquiry/enquiryService";

export default {
  name: "enquiry_statistics",
  components: {
    VeLine,
    VePie,
    enquiryCount,
    enquiryRegion,
    enquiryIndustry,
    enquiryService
  },
  created() {
    if (this.$route.query.id) {
      this.customerId = this.$route.query.id;
    }
    this.getTrend();
    this.getRegion();
  },
  data() {
    return {
      service: inquiry,
      customerId: undefined,
      options: websiteType,
      dateTypeDict: dateType,
      timeType: 0,
      trendQueryCondition: {
        serviceId: "",
        websiteType: undefined
      },
      trend: {
        config: {
          labelMap: {
            submitDate: "时间",
            num: "询盘数量"
          }
        },
        data: {
          columns: ["submitDate", "num"],
          rows: []
        }
      },
      region: {
        config: {
          labelMap: {
            region: "地区",
            num: "询盘数量"
          }
        },
        data: {
          columns: ["region", "totalNum"],
          rows: []
        }
      }
    };
  },
  watch: {
    trendQueryCondition: {
      handler() {
        this.getTrend();
      },
      deep: true
    }
  },
  methods: {
    setDateType({ label, value }) {
      this.timeType = value;
      this.getTrend();
    },
    getCommon() {
      return {
        customerId: this.customerId,
        timeType: this.timeType
      };
    },
    getQuery() {
      return {
        ...this.getCommon(),
        ...this.trendQueryCondition
      };
    },
    async getTrend() {
      let data = await inquiry.inquiryTrend(this.getQuery());
      this.trend.data.rows = data.data;
    },
    async getRegion() {
      let data = await inquiry.inquiryRegion(this.getCommon());
      this.region.data.rows = data.data;
    }
  }
};
</script>

<style lang="scss" scoped>
.block-indent {
  margin-top: 20px;
}
</style>
